import * as React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { InputLabel, Paper } from '@mui/material';
// ใช้งานล่าสุด
const StyledAutocomplete = styled(Autocomplete)({
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
        // Default transform is "translate(14px, 20px) scale(1)""
        // This lines up the label with the initial cursor position in the input
        // after changing its padding-left.
        transform: "translate(34px, 20px) scale(1);"
    },
    "& .MuiAutocomplete-inputRoot": {
        color: "back",
        fontFamily: "Customfont !important",
        // This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
        '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
            // Default left padding is 6px
            paddingLeft: 26
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "green"
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "red"
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "purple"
        }
    }
});
export default function UseAutocompletes(arg) {
    const autoC = React.useRef(null);
    const { datalist, id, title, defaultvalue, adddataenable, placeholder } = arg
    const [value, setValue] = React.useState(null);
    
    // ✅ useEffect สำหรับ sync value กับ defaultvalue
    React.useEffect(() => {
        // ไม่ได้ส่ง defaultvalue มา = ผู้ใช้เป็นคนเลือกเอง ไม่ต้องล้างค่าที่เลือกไว้เมื่อ datalist เปลี่ยน
        if (typeof defaultvalue === "undefined") return;
        if (typeof datalist !== "undefined" && datalist.length > 0) {
            if (defaultvalue && defaultvalue !== "") {
                // หา object ที่ตรงกับ defaultvalue (CODE)
                const foundItem = datalist.find(item => item.CODE === defaultvalue);
                if (foundItem) {
                    setValue(foundItem);
                } else {
                    setValue(null);
                }
            } else {
                // ถ้า defaultvalue เป็น empty string ให้รีเซทค่า
                setValue(null);
            }
        } else {
            setValue(null);
        }
    }, [defaultvalue, datalist]);
    
    const onClick = () => {
        console.log("onClick activate");
        arg.activate()
    }
    
    // Autocomplete with title (label on left side)
    const AutocompleteWithTitle = <StyledAutocomplete
        ref={autoC}
        fullWidth={true}
        sx={{
            mt: '5px',
            mb: '5px',
            width: '100%',              // ✅ บังคับให้เต็มพื้นที่
            maxWidth: '100%',           // ✅ ไม่ให้เกินพื้นที่
            "& label.Mui-focused": {
                display: "none",
            },
            "& legend": {
                display: "none",
            },
            "& .MuiInput-root": {
                height: "30px",
                padding: "0 !important",
                margin: "0 !important",
                boxSizing: "border-box",
                display: "flex",
                alignItems: "center",
                width: '100%',          // ✅ บังคับให้เต็มพื้นที่
                maxWidth: '100%',       // ✅ ไม่ให้เกินพื้นที่
                "& .MuiAutocomplete-input": {
                    height: "22px",
                    backgroundColor: "#fff",
                    padding: "4px",
                    fontFamily: "Customfont",
                    fontSize: "13px",
                    lineHeight: "22px",
                },
                "&:before": {
                    display: 'none'
                },
                "&:after": {
                    display: 'none'
                },
                "&:hover:before": {
                    display: 'none'
                },
                "&.Mui-focused:after": {
                    display: 'none'
                }
            },
            "& .MuiButtonBase-root.MuiIconButton-root": {
                padding: "0px"
            }
        }}
        loadingText='กำลังโหลด...'
        value={value}
        clearOnBlur
        // disableClearable
        onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
                setValue({
                    MYNAMETH: newValue,
                });
            } else if (newValue && newValue.inputValue) {
                // Create a new value from the user input
                setValue({
                    MYNAMETH: newValue.inputValue,
                });
                arg.valueReturn([{ "CODE": 0, "MYNAMETH": newValue.inputValue }])
            } else {
                try {
                    setValue(newValue);
                    arg.valueReturn([{ "CODE": newValue.CODE, "MYNAMETH": newValue.MYNAMETH }])
                } catch (error) {
                    console.log(error);
                }
            }
            // console.log("newValue", newValue.CODE);
        }
        } 
        size="small"
        filterOptions={(options, params) => {
            const { inputValue } = params;
            if (!inputValue) return options;
            
            // ✅ ค้นหาทั้ง CODE และ MYNAMETH (case-insensitive)
            const searchText = inputValue.toLowerCase();
            const filtered = options.filter((option) => {
                const code = String(option.CODE ?? "").toLowerCase();
                const name = String(option.MYNAMETH ?? "").toLowerCase();
                return code.includes(searchText) || name.includes(searchText);
            });
            
            // Suggest the creation of a new value
            const isExisting = options.some((option) => inputValue === option.MYNAMETH);
            if (inputValue !== '' && !isExisting && adddataenable == true) {
                filtered.push({
                    inputValue,
                    MYNAMETH: `เพิ่ม "${inputValue}"`,
                });
            }
            return filtered;
        }}
        selectOnFocus
        handleHomeEndKeys
        blurOnSelect={false}
        id={id}
        options={datalist}
        getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
                return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
                return option.inputValue;
            }
            // Regular option - แสดง CODE - MYNAMETH
            const code = option.CODE || '';
            const name = option.MYNAMETH || '';
            return code ? `${code} - ${name}` : name;
        }}
        renderOption={(props, option) => {
            const code = option.CODE || '';
            const name = option.MYNAMETH || '';
            const displayText = code ? `${code} - ${name}` : name;
            return (
                <li {...props} style={{ fontFamily: "Customfont" }}>
                    {displayText}
                </li>
            );
        }}
        freeSolo
        onInputChange={(event, newInputValue) => {
            //console.log("newInputValue", newInputValue)
            // setInputValue(newInputValue); 
            if (newInputValue === "") {
                arg.valueReturn([{ "CODE": "", "MYNAMETH": "" }])
            }
        }}
        onOpen={_ => arg.activate()}
        renderInput={(params) => (
            <TextField {...params}
                variant="standard"
                size="small"
                placeholder={placeholder}
                sx={{ 
                    backgroundColor: "#fff",
                    height: '30px',
                    "& .MuiInputLabel-root": {
                        display: "none",
                    },
                    "& .MuiInput-root": {
                        height: '30px',
                        padding: '0 4px',
                        fontFamily: 'Customfont',
                        fontSize: '13px',
                        '&:before': {
                            display: 'none'
                        },
                        '&:after': {
                            display: 'none'
                        }
                    },
                    "& .MuiInput-input": {
                        padding: '4px',
                        height: '22px',
                        fontFamily: 'Customfont',
                        fontSize: '13px'
                    }
                }}
                InputLabelProps={{
                    shrink: false,
                    style: { display: 'none' }
                }}
            />
        )}
    />
    
    // Autocomplete without title (standalone input)
    const AutocompleteStandalone = <StyledAutocomplete
        ref={autoC}
        fullWidth={true}
        sx={{
            mt: '5px',
            mb: '5px',
            "& label.Mui-focused": {
                display: "none",
            },
            "& legend": {
                display: "none",
            },
            "& .MuiOutlinedInput-root": {
                height: "30px",
                borderRadius: "4px",
                "& .MuiAutocomplete-input": {
                    height: "30px",
                    backgroundColor: "#fff",
                    padding: "0 10px",
                    fontFamily: "Customfont",
                    fontSize: "13px",
                    lineHeight: "30px",
                    boxSizing: 'border-box'
                },
                "& fieldset": {
                    border: '1px solid #ccc !important',
                    borderRadius: "4px",
                    boxShadow: 'none !important'
                },
                "&:hover fieldset": {
                    border: '1px solid #ccc !important',
                    boxShadow: 'none !important'
                },
                "&.Mui-focused fieldset": {
                    border: '1px solid #ccc !important',
                    boxShadow: 'none !important'
                },
            },
            "& .MuiButtonBase-root.MuiIconButton-root": {
                padding: "2px"
            }
        }}
        loadingText='กำลังโหลด...'
        value={value}
        clearOnBlur
        // disableClearable
        onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
                setValue({
                    MYNAMETH: newValue,
                });
            } else if (newValue && newValue.inputValue) {
                // Create a new value from the user input
                setValue({
                    MYNAMETH: newValue.inputValue,
                });
                arg.valueReturn([{ "CODE": 0, "MYNAMETH": newValue.inputValue }])
            } else {
                try {
                    setValue(newValue);
                    arg.valueReturn([{ "CODE": newValue.CODE, "MYNAMETH": newValue.MYNAMETH }])
                } catch (error) {
                    console.log(error);
                }
            }
            // console.log("newValue", newValue.CODE);
        }
        }
        variant="standard"
        size="small"
        filterOptions={(options, params) => {
            const { inputValue } = params;
            if (!inputValue) return options;
            
            // ✅ ค้นหาทั้ง CODE และ MYNAMETH (case-insensitive)
            const searchText = inputValue.toLowerCase();
            const filtered = options.filter((option) => {
                const code = String(option.CODE ?? "").toLowerCase();
                const name = String(option.MYNAMETH ?? "").toLowerCase();
                return code.includes(searchText) || name.includes(searchText);
            });
            
            // Suggest the creation of a new value
            const isExisting = options.some((option) => inputValue === option.MYNAMETH);
            if (inputValue !== '' && !isExisting && adddataenable == true) {
                filtered.push({
                    inputValue,
                    MYNAMETH: `เพิ่ม "${inputValue}"`,
                });
            }
            return filtered;
        }}
        selectOnFocus
        handleHomeEndKeys
        blurOnSelect={false}
        id={id}
        options={datalist}
        getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
                return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
                return option.inputValue;
            }
            // Regular option - แสดง CODE - MYNAMETH
            const code = option.CODE || '';
            const name = option.MYNAMETH || '';
            return code ? `${code} - ${name}` : name;
        }}
        renderOption={(props, option) => {
            const code = option.CODE || '';
            const name = option.MYNAMETH || '';
            const displayText = code ? `${code} - ${name}` : name;
            return (
                <li {...props} style={{ fontFamily: "Customfont" }}>
                    {displayText}
                </li>
            );
        }}
        freeSolo
        onInputChange={(event, newInputValue) => {
            //console.log("newInputValue", newInputValue)
            // setInputValue(newInputValue); 
            if (newInputValue === "") {
                arg.valueReturn([{ "CODE": "", "MYNAMETH": "" }])
            }
        }}
        onOpen={_ => arg.activate()}
        renderInput={(params) => (
            <TextField {...params}
                sx={{
                    backgroundColor: "#fff",
                    "& .MuiInputLabel-root": {
                        display: "none",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: 'none'
                    },
                    "& .MuiOutlinedInput-root": {
                        boxShadow: 'none'
                    }
                }}
                placeholder={placeholder}
                variant="outlined"
                size="small"
                InputLabelProps={{
                    shrink: false,
                    style: { display: 'none' }
                }}
            />
        )}
    />
    const displayWithTitle = (
        <div style={{
            display: 'flex',
            alignItems: 'stretch',
            width: '100%',
            marginTop: '5px',
            marginBottom: '5px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            overflow: 'hidden',
            minHeight: '30px',
            height: '30px',
            margin: 0
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#eee',
                borderRight: '1px solid #ccc',
                padding: '6px 12px',
                minWidth: '120px',
                maxWidth: '180px',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                fontSize: '14px',
                fontFamily: 'Customfont',
                color: '#555',
                fontWeight: '600',
                lineHeight: '1.42857143',
                height: '30px'
            }}>
                {title}
            </div>
            <div style={{ 
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#fff',
                height: '100%',
                overflow: 'hidden'
            }}>
                {AutocompleteWithTitle}
            </div>
        </div>
    )
    return (<>
        {title !== "" ? displayWithTitle : AutocompleteStandalone}
    </>
    );
}
UseAutocompletes.propTypes = {
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    datalist: PropTypes.array.isRequired,
    defaultvalue: PropTypes.string,
    adddataenable: PropTypes.bool
}